// import React, { useState } from 'react';
// import {
//   Form,
//   Input,
//   Button,
//   Upload,
//   Table,
//   Card,
//   message,
//   Space,
//   Image,
//   Popconfirm
// } from 'antd';
// import {
//   UploadOutlined,
//   DeleteOutlined,
//   EditOutlined,
//   PlusOutlined
// } from '@ant-design/icons';
// import bannerService from '../services/bannerService';
// import { useApiEnhanced } from '../hooks/useApiEnhanced';
// import { toast } from 'react-toastify';

// const BannerManagement = () => {

//    const {
//     data: banners,
//     loading,
//     error,
//     execute: refreshBanners
//   } = useApiEnhanced(
//     () => bannerService.getBanners({ page: 1, limit: 10 }),
//     true // Load immediately
//   );
//    const {
//     loading: creating,
//     execute: createBanner
//   } = useApiEnhanced(
//     (productData) => bannerService.createBanner(productData),
//     {immediate:false} // Don't execute on mount
//   );

// console.log(banners,"banners")
//   const [form] = Form.useForm();
// //   const [banners, setBanners] = useState([]);
//   const [editingId, setEditingId] = useState(null);

//   // Handle form submission
//   const handleSubmit =async  (values) => {
//     let file = null;
//     if (values.image && values.image.length > 0) {
//       // Get the actual file object
//       file = values.image[0].originFileObj || values.image[0];
//     }

//     console.log('File object:', file); // Debug log

//     const formData = new FormData();

//     // Add all text fields
//     formData.append('title', values.title);
//     formData.append('url', values.url || '');

//     // Add image file if it exists
//     if (file) {
//       formData.append('image', file);
//       console.log('Image appended to FormData'); // Debug log
//     } else {
//       console.log('No image file found'); // Debug log
//     }
//     // const bannerData = {
//     //   id: editingId || Date.now(),
//     //   title: values.title,
//     //   url: values.url,
//     //   image: imageUrl,
//     //   createdAt: editingId ? banners.find(b => b.id === editingId)?.createdAt : new Date().toLocaleString()
//     // };

//     if (editingId) {
//       // Update existing banner
//     //   setBanners(banners.map(banner =>
//     //     banner.id === editingId ? bannerData : banner
//     //   ));
//       setEditingId(null);
//       message.success('Banner updated successfully!');
//     } else {
//       // Add new banner
//     //   setBanners([...banners, bannerData]);
//     let res = await createBanner(formData)
//     if(!res?.success) return toast.error(res?.message||'Not created')
//       toast.success('Banner added successfully!');
//     }

//     form.resetFields();
//   };

//   // Handle edit
//   const handleEdit = (record) => {
//     setEditingId(record.id);
//     form.setFieldsValue({
//       title: record.title,
//       url: record.url,
//       image: record.image ? [{ uid: '-1', name: 'image', status: 'done', url: record.image }] : []
//     });
//   };

//   // Handle delete
//   const handleDelete = (id) => {
//     // setBanners(banners.filter(banner => banner.id !== id));
//     message.success('Banner deleted successfully!');
//   };

//   // Cancel editing
//   const handleCancel = () => {
//     setEditingId(null);
//     form.resetFields();
//   };

//   // Upload props
//   const uploadProps = {
//     beforeUpload: (file) => {
//       const isImage = file.type.startsWith('image/');
//       if (!isImage) {
//         message.error('You can only upload image files!');
//         return false;
//       }
//       const isLt2M = file.size / 1024 / 1024 < 2;
//       if (!isLt2M) {
//         message.error('Image must be smaller than 2MB!');
//         return false;
//       }
//       return false; // Prevent auto upload
//     },
//     maxCount: 1,
//     listType: 'picture',
//     onChange: (info) => {
//       // Handle file preview
//       if (info.file.originFileObj) {
//         const reader = new FileReader();
//         reader.onload = (e) => {
//           info.file.thumbUrl = e.target.result;
//         };
//         reader.readAsDataURL(info.file.originFileObj);
//       }
//     }
//   };

//   // Table columns
//   const columns = [
//     {
//       title: 'Image',
//       dataIndex: 'image',
//       key: 'image',
//       width: 100,
//       render: (image) => (
//         image ? (
//           <Image
//             width={60}
//             height={40}
//             src={image}
//             style={{ objectFit: 'cover', borderRadius: '4px' }}
//             fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RUG8O+L"
//           />
//         ) : (
//           <div className="w-15 h-10 bg-gray-100 rounded flex items-center justify-center">
//             <span className="text-gray-400 text-xs">No Image</span>
//           </div>
//         )
//       ),
//     },
//     {
//       title: 'Title',
//       dataIndex: 'title',
//       key: 'title',
//       ellipsis: true,
//     },
//     {
//       title: 'URL',
//       dataIndex: 'url',
//       key: 'url',
//       ellipsis: true,
//       render: (url) => (
//         <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-500">
//           {url}
//         </a>
//       ),
//     },
//     {
//       title: 'Created At',
//       dataIndex: 'createdAt',
//       key: 'createdAt',
//       width: 150,
//     },
//     {
//       title: 'Actions',
//       key: 'actions',
//       width: 120,
//       render: (_, record) => (
//         <Space>
//           <Button
//             type="primary"
//             size="small"
//             icon={<EditOutlined />}
//             onClick={() => handleEdit(record)}
//           />
//           <Popconfirm
//             title="Are you sure you want to delete this banner?"
//             onConfirm={() => handleDelete(record.id)}
//             okText="Yes"
//             cancelText="No"
//           >
//             <Button
//               type="primary"
//               danger
//               size="small"
//               icon={<DeleteOutlined />}
//             />
//           </Popconfirm>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <div className="max-w-6xl mx-auto p-6">
//       <h1 className="text-3xl font-bold text-gray-800 mb-8">Banner Management System</h1>

//       {/* Form Section */}
//       <Card title={editingId ? "Edit Banner" : "Add New Banner"} className="mb-8">
//         <Form
//           form={form}
//           layout="vertical"
//           onFinish={handleSubmit}
//           className="max-w-2xl"
//         >
//           <Form.Item
//             label="Banner Image"
//             name="image"
//             rules={[{ required: true, message: 'Please upload an image!' }]}
//           >
//             <Upload {...uploadProps}>
//               <Button icon={<UploadOutlined />}>Click to Upload</Button>
//             </Upload>

//           </Form.Item>

//           <Form.Item
//             label="Title"
//             name="title"
//             rules={[
//               { required: true, message: 'Please input the banner title!' },
//               { max: 100, message: 'Title must be less than 100 characters!' }
//             ]}
//           >
//             <Input placeholder="Enter banner title" />
//           </Form.Item>

//           <Form.Item
//             label="URL"
//             name="url"
//             rules={[
//               { required: false, message: 'Please input the banner URL!' },
//               { type: 'url', message: 'Please enter a valid URL!' }
//             ]}
//           >
//             <Input placeholder="https://example.com" />
//           </Form.Item>

//           <Form.Item>
//             <Space>
//               <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
//                 {editingId ? 'Update Banner' : 'Add Banner'}
//               </Button>
//               {editingId && (
//                 <Button onClick={handleCancel}>
//                   Cancel
//                 </Button>
//               )}
//             </Space>
//           </Form.Item>
//         </Form>
//       </Card>

//       {/* Table Section */}
//       <Card title="Banner List">
//         <Table
//           columns={columns}
//           dataSource={banners?.data||[]}
//           rowKey="id"
//           pagination={{
//             pageSize: 10,
//             showSizeChanger: true,
//             showQuickJumper: true,
//             showTotal: (total, range) =>
//               `${range[0]}-${range[1]} of ${total} items`,
//           }}
//           locale={{
//             emptyText: 'No banners added yet. Add your first banner above!'
//           }}
//         />
//       </Card>
//     </div>
//   );
// };

// export default BannerManagement;

// import React, { useState } from 'react';
// import {
//   Form,
//   Input,
//   Button,
//   Upload,
//   Table,
//   Card,
//   message,
//   Space,
//   Image,
//   Popconfirm
// } from 'antd';
// import {
//   UploadOutlined,
//   DeleteOutlined,
//   EditOutlined,
//   PlusOutlined
// } from '@ant-design/icons';
// import bannerService from '../services/bannerService';
// import { useApiEnhanced } from '../hooks/useApiEnhanced';
// import { toast } from 'react-toastify';

// const BannerManagement = () => {
//   const {
//     data: banners,
//     loading,
//     error,
//     execute: refreshBanners
//   } = useApiEnhanced(
//     () => bannerService.getBanners({ page: 1, limit: 10 }),
//     true // Load immediately
//   );

//   const {
//     loading: creating,
//     execute: createBanner
//   } = useApiEnhanced(
//     (productData) => bannerService.createBanner(productData),
//     {immediate:false} // Don't execute on mount
//   );

//    const {
//     loading: updating,
//     execute: updateBanner
//   } = useApiEnhanced(
//     (id,productData) => bannerService.updateBanner(id,productData),
//     {immediate:false} // Don't execute on mount
//   );

//     const {
//     loading: deleteing,
//     execute: deleteBanner
//   } = useApiEnhanced(
//     (id) => bannerService.deleteBanner(id),
//     {immediate:false} // Don't execute on mount
//   );

//   console.log(banners,"banners")

//   const [form] = Form.useForm();
//   const [editingId, setEditingId] = useState(null);

//   // Add state for image file and URL (like ProductsSection)
//   const [imageUrl, setImageUrl] = useState('');
//   const [imageFile, setImageFile] = useState(null);

//   // Image upload handler (like ProductsSection)
//   const handleImageUpload = (info) => {
//     const file = info.file.originFileObj || info.file;

//     // Store the actual file object
//     setImageFile(file);

//     // Create preview URL
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       setImageUrl(e.target.result);
//     };
//     reader.readAsDataURL(file);
//   };

//   const customUpload = ({ file, onSuccess }) => {
//     // Just store the file, don't upload yet
//     setTimeout(() => {
//       onSuccess("ok");
//     }, 0);
//   };

//   // Handle form submission
//   const handleSubmit = async (values) => {
//     console.log('Form values received:', values); // Debug log

//     try {
//       // Create FormData for multipart upload
//       const formData = new FormData();

//       // Add all text fields
//       if(values?.title)
//           formData.append('title', values.title);
//       formData.append('url', values.url || '');

//       // Add image if exists (using the imageFile state like in ProductsSection)
//       if (imageFile) {
//         formData.append('image', imageFile);
//         console.log('✅ Image file appended to FormData:', imageFile.name);
//       } else {
//         console.log('❌ No image file found');
//         toast.error('Please select an image file');
//         return;
//       }

//       // Debug FormData contents
//       console.log('FormData contents:');
//       for (let pair of formData.entries()) {
//         console.log(`${pair[0]}:`, pair[1]);
//       }

//       if (editingId) {
//         // Update existing banner
//         setEditingId(null);
//         let res = await updateBanner(editingId,formData)
//          if (!res?.success) {
//           return toast.error(res?.message || 'Banner not Updated');
//         }
//          toast.success('Banner updated successfully!');
//       } else {
//         // Add new banner
//         console.log('Calling createBanner with FormData...');
//         let res = await createBanner(formData);
//         if (!res?.success) {
//           return toast.error(res?.message || 'Banner not created');
//         }
//         toast.success('Banner added successfully!');

//         // Refresh banner list

//       }
//          refreshBanners();

//       // Reset form and image state
//       form.resetFields();
//       setImageFile(null);
//       setImageUrl('');

//     } catch (error) {
//       console.error('Error creating banner:', error);
//       toast.error('Error creating banner: ' + error.message);
//     }
//   };

//   // Handle edit
//   const handleEdit = (record) => {
//     setEditingId(record._id);
//     setImageUrl(record.image?.url || '');
//     form.setFieldsValue({
//       title: record.title,
//       url: record.url,
//       image: record.image ? [{ uid: '-1', name: 'image', status: 'done', url: record.image?.url }] : []
//     });
//   };

//   // Handle delete
//   const handleDelete = async (id) => {
//     try {
//         // setBanners(banners.filter(banner => banner.id !== id));
//     let res = await deleteBanner(id)
//     if(!res?.success) return toast.error(res?.message||"Not able to delete")
//     toast.success('Banner deleted successfully!');
//     refreshBanners()
//     } catch (error) {
//         toast.error("Not able to delete")
//     }

//   };

//   // Cancel editing
//   const handleCancel = () => {
//     setEditingId(null);
//     form.resetFields();
//     setImageFile(null);
//     setImageUrl('');
//   };

//   // Upload props (updated like ProductsSection)
//   const uploadProps = {
//     name: "avatar",
//     listType: "picture-card",
//     className: "avatar-uploader",
//     showUploadList: false,
//     customRequest: customUpload,
//     beforeUpload: (file) => {
//       const isImage = file.type.startsWith('image/');
//       if (!isImage) {
//         toast.error('You can only upload image files!');
//         return false;
//       }
//       const isLt2M = file.size / 1024 / 1024 < 2;
//       if (!isLt2M) {
//         toast.error('Image must be smaller than 2MB!');
//         return false;
//       }
//       return true;
//     },
//     onChange: handleImageUpload,
//   };

//   // Table columns
//   const columns = [
//     {
//       title: 'Image',
//       dataIndex: 'image',
//       key: 'image',
//       width: 100,
//       render: (image) => (
//         image ? (
//           <Image
//             width={60}
//             height={40}
//             src={image?.url}
//             style={{ objectFit: 'cover', borderRadius: '4px' }}
//             fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RUG8O+L"
//           />
//         ) : (
//           <div className="w-15 h-10 bg-gray-100 rounded flex items-center justify-center">
//             <span className="text-gray-400 text-xs">No Image</span>
//           </div>
//         )
//       ),
//     },
//     {
//       title: 'Title',
//       dataIndex: 'title',
//       key: 'title',
//       ellipsis: true,
//       render: (title,rec) => (
//        <p>{rec?.title!="undefined"?rec?.title:'-'}</p>
//       ),
//     },
//     {
//       title: 'URL',
//       dataIndex: 'url',
//       key: 'url',
//       ellipsis: true,
//       render: (url) => (
//         <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-500">
//           {url}
//         </a>
//       ),
//     },
//     {
//       title: 'Created At',
//       dataIndex: 'createdAt',
//       key: 'createdAt',
//       width: 150,
//     },
//     {
//       title: 'Actions',
//       key: 'actions',
//       width: 120,
//       render: (_, record) => (
//         <Space>
//           <Button
//             type="primary"
//             size="small"
//             icon={<EditOutlined />}
//             onClick={() => handleEdit(record)}
//           />
//           <Popconfirm
//             title="Are you sure you want to delete this banner?"
//             onConfirm={() => handleDelete(record._id)}
//             okText="Yes"
//             cancelText="No"
//           >
//             <Button
//               type="primary"
//               danger
//               size="small"
//               icon={<DeleteOutlined />}
//             />
//           </Popconfirm>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <div className="max-w-6xl mx-auto p-6">
//       <h1 className="text-3xl font-bold text-gray-800 mb-8">Banner Management System</h1>

//       {/* Form Section */}
//       <Card title={editingId ? "Edit Banner" : "Add New Banner"} className="mb-8">
//         <Form
//           form={form}
//           layout="vertical"
//           onFinish={handleSubmit}
//           className="max-w-2xl"
//         >
//           <Form.Item
//             label="Banner Image"
//             name="image"
//             rules={[{ required: true, message: 'Please upload an image!' }]}
//           >
//             <Upload {...uploadProps}>
//               {imageUrl ? (
//                 <img src={imageUrl} alt="Banner" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//               ) : (
//                 <div>
//                   <PlusOutlined />
//                   <div style={{ marginTop: 8 }}>Upload</div>
//                 </div>
//               )}
//             </Upload>
//           </Form.Item>

//           <Form.Item
//             label="Title"
//             name="title"
//             rules={[
//               { required: false, message: 'Please input the banner title!' },
//               { max: 100, message: 'Title must be less than 100 characters!' }
//             ]}
//           >
//             <Input placeholder="Enter banner title" />
//           </Form.Item>

//           <Form.Item
//             label="URL"
//             name="url"
//             rules={[
//               { required: false, message: 'Please input the banner URL!' },
//               { type: 'url', message: 'Please enter a valid URL!' }
//             ]}
//           >
//             <Input placeholder="https://example.com" />
//           </Form.Item>

//           <Form.Item>
//             <Space>
//               <Button type="primary" htmlType="submit" icon={<PlusOutlined />} loading={creating}>
//                 {editingId ? 'Update Banner' : 'Add Banner'}
//               </Button>
//               {editingId && (
//                 <Button onClick={handleCancel}>
//                   Cancel
//                 </Button>
//               )}
//             </Space>
//           </Form.Item>
//         </Form>
//       </Card>

//       {/* Table Section */}
//       <Card title="Banner List">
//         <Table
//           columns={columns}
//           dataSource={banners?.data||[]}
//           loading={loading}
//           rowKey="_id"
//           pagination={{
//             pageSize: 10,
//             showSizeChanger: true,
//             showQuickJumper: true,
//             showTotal: (total, range) =>
//               `${range[0]}-${range[1]} of ${total} items`,
//           }}
//           locale={{
//             emptyText: 'No banners added yet. Add your first banner above!'
//           }}
//         />
//       </Card>
//     </div>
//   );
// };

// export default BannerManagement;

import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Table,
  Card,
  message,
  Space,
  Image,
  Popconfirm,
  Select,
  Tag,
} from "antd";
import {
  UploadOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import bannerService from "../services/bannerService";
import { useApiEnhanced } from "../hooks/useApiEnhanced";
import { toast } from "react-toastify";

const { Option } = Select;

const BannerManagement = () => {
  const {
    data: banners,
    loading,
    error,
    execute: refreshBanners,
  } = useApiEnhanced(
    () => bannerService.getBanners({ page: 1, limit: 10 }),
    true // Load immediately
  );

  const { loading: creating, execute: createBanner } = useApiEnhanced(
    (productData) => bannerService.createBanner(productData),
    { immediate: false } // Don't execute on mount
  );

  const { loading: updating, execute: updateBanner } = useApiEnhanced(
    (id, productData) => bannerService.updateBanner(id, productData),
    { immediate: false } // Don't execute on mount
  );

  const { loading: deleteing, execute: deleteBanner } = useApiEnhanced(
    (id) => bannerService.deleteBanner(id),
    { immediate: false } // Don't execute on mount
  );

  console.log(banners, "banners");

  const [form] = Form.useForm();
  const [editingId, setEditingId] = useState(null);

  // Add state for image file and URL (like ProductsSection)
  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState(null);

  // Banner index options
  const bannerIndexOptions = [
    { value: "banner1", label: "Banner 1" },
    { value: "banner2", label: "Banner 2" },
  ];

  // Image upload handler (like ProductsSection)
  const handleImageUpload = (info) => {
    const file = info.file.originFileObj || info.file;

    // Store the actual file object
    setImageFile(file);

    // Create preview URL
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageUrl(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const customUpload = ({ file, onSuccess }) => {
    // Just store the file, don't upload yet
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  // Handle form submission
  const handleSubmit = async (values) => {
    console.log("Form values received:", values); // Debug log

    try {
      // Create FormData for multipart upload
      const formData = new FormData();

      // Add all text fields
      if (values?.title) formData.append("title", values.title);
      formData.append("url", values.url || "");

      // Add banner index
      if (values?.index) {
        formData.append("bannerIndex", values.index);
      } else {
        toast.error("Please select a banner index");
        return;
      }

      // Add image if exists (using the imageFile state like in ProductsSection)
      if (imageFile) {
        formData.append("image", imageFile);
        console.log("✅ Image file appended to FormData:", imageFile.name);
      } else if (!editingId) {
        // Only require image for new banners
        console.log("❌ No image file found");
        toast.error("Please select an image file");
        return;
      }

      // Debug FormData contents
      console.log("FormData contents:");
      for (let pair of formData.entries()) {
        console.log(`${pair[0]}:`, pair[1]);
      }

      if (editingId) {
        // Update existing banner
        setEditingId(null);
        let res = await updateBanner(editingId, formData);
        if (!res?.success) {
          return toast.error(res?.message || "Banner not Updated");
        }
        toast.success("Banner updated successfully!");
      } else {
        // Add new banner
        console.log("Calling createBanner with FormData...");
        let res = await createBanner(formData);
        if (!res?.success) {
          return toast.error(res?.message || "Banner not created");
        }
        toast.success("Banner added successfully!");

        // Refresh banner list
      }
      refreshBanners();

      // Reset form and image state
      form.resetFields();
      setImageFile(null);
      setImageUrl("");
    } catch (error) {
      console.error("Error creating banner:", error);
      toast.error("Error creating banner: " + error.message);
    }
  };

  // Handle edit
  const handleEdit = (record) => {
    setEditingId(record._id);
    setImageUrl(record.image?.url || "");
    form.setFieldsValue({
      title: record.title,
      url: record.url,
      index: record.index,
      image: record.image
        ? [{ uid: "-1", name: "image", status: "done", url: record.image?.url }]
        : [],
    });
  };

  // Handle delete
  const handleDelete = async (id) => {
    try {
      // setBanners(banners.filter(banner => banner.id !== id));
      let res = await deleteBanner(id);
      if (!res?.success)
        return toast.error(res?.message || "Not able to delete");
      toast.success("Banner deleted successfully!");
      refreshBanners();
    } catch (error) {
      toast.error("Not able to delete");
    }
  };

  // Cancel editing
  const handleCancel = () => {
    setEditingId(null);
    form.resetFields();
    setImageFile(null);
    setImageUrl("");
  };

  // Upload props (updated like ProductsSection)
  const uploadProps = {
    name: "avatar",
    listType: "picture-card",
    className: "avatar-uploader",
    showUploadList: false,
    customRequest: customUpload,
    beforeUpload: (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        toast.error("You can only upload image files!");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        toast.error("Image must be smaller than 2MB!");
        return false;
      }
      return true;
    },
    onChange: handleImageUpload,
  };

  // Get banner index label
  const getBannerIndexLabel = (index) => {
    const option = bannerIndexOptions.find((opt) => opt.value === index);
    return option ? option.label : index;
  };

  // Get banner index color
  const getBannerIndexColor = (index) => {
    switch (index) {
      case "banner1":
        return "blue";
      case "banner2":
        return "green";
      default:
        return "default";
    }
  };

  // Table columns
  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      width: 100,
      render: (image) =>
        image ? (
          <Image
            width={60}
            height={40}
            src={image?.url}
            style={{ objectFit: "cover", borderRadius: "4px" }}
            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RUG8O+L"
          />
        ) : (
          <div className="w-15 h-10 bg-gray-100 rounded flex items-center justify-center">
            <span className="text-gray-400 text-xs">No Image</span>
          </div>
        ),
    },
    {
      title: "Index",
      dataIndex: "bannerIndex",
      key: "index",
      width: 120,
      render: (index) => (
        <Tag color={getBannerIndexColor(index)}>
          {getBannerIndexLabel(index)}
        </Tag>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      ellipsis: true,
      render: (title, rec) => (
        <p>{rec?.title != "undefined" ? rec?.title : "-"}</p>
      ),
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      ellipsis: true,
      render: (url) => (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500"
        >
          {url}
        </a>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
    },
    {
      title: "Actions",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            size="small"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          />
          <Popconfirm
            title="Are you sure you want to delete this banner?"
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="primary"
              danger
              size="small"
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="max-w-6xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">
        Banner Management System
      </h1>

      {/* Form Section */}
      <Card
        title={editingId ? "Edit Banner" : "Add New Banner"}
        className="mb-8"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="max-w-2xl"
        >
          <Form.Item
            label="Banner Index"
            name="index"
            rules={[
              { required: true, message: "Please select a banner index!" },
            ]}
          >
            <Select
              placeholder="Select banner position"
              style={{ width: "100%" }}
            >
              {bannerIndexOptions.map((option) => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Banner Image"
            name="image"
            rules={[
              { required: !editingId, message: "Please upload an image!" },
            ]}
          >
            <Upload {...uploadProps}>
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="Banner"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              )}
            </Upload>
          </Form.Item>

          <Form.Item
            label="Title"
            name="title"
            rules={[
              { required: false, message: "Please input the banner title!" },
              { max: 100, message: "Title must be less than 100 characters!" },
            ]}
          >
            <Input placeholder="Enter banner title" />
          </Form.Item>

          <Form.Item
            label="URL"
            name="url"
            rules={[
              { required: false, message: "Please input the banner URL!" },
              { type: "url", message: "Please enter a valid URL!" },
            ]}
          >
            <Input placeholder="https://example.com" />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                icon={<PlusOutlined />}
                loading={creating || updating}
              >
                {editingId ? "Update Banner" : "Add Banner"}
              </Button>
              {editingId && <Button onClick={handleCancel}>Cancel</Button>}
            </Space>
          </Form.Item>
        </Form>
      </Card>

      {/* Table Section */}
      <Card title="Banner List">
        <Table
          columns={columns}
          dataSource={banners?.data || []}
          loading={loading}
          rowKey="_id"
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
          locale={{
            emptyText: "No banners added yet. Add your first banner above!",
          }}
        />
      </Card>
    </div>
  );
};

export default BannerManagement;
